"use client";

import React from "react";
import { MapPin, Phone, Mail, Send, Loader, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const serviceOptions = [{
  value: "satellite",
  label: "Արբանյակային Պատկերների Ստացում"
}, {
  value: "photogrammetry",
  label: "Ֆոտոգրամետրիական աշխատանքներ"
}, {
  value: "geodesy",
  label: "Գեոդեզիական աշխատանքներ"
}, {
  value: "consultation",
  label: "Մասնագիտական խորհրդատվություն"
}, {
  value: "other",
  label: "Այլ"
}];
const contactInfo = [{
  icon: MapPin,
  title: "Հասցե",
  details: "Երևան, Հայաստան"
}, {
  icon: Phone,
  title: "Հեռախոս",
  details: "+374 10 000 000"
}, {
  icon: Mail,
  title: "Էլ. հասցե",
  details: "info@example.am"
}];
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-foreground">Շնորհակալություն</h3>
        <p className="text-muted-foreground max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Ուղարկել նոր հարցում
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Անունը պարտադիր է",
        minLength: {
          value: 2,
          message: "Նվազագույնը 2 նիշ"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Անուն Ազգանուն</FormLabel>
              <FormControl>
                <Input placeholder="Ձեր անունը" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Էլ. հասցեն պարտադիր է",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Անվավեր էլ. հասցե"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Էլ. հասցե</FormLabel>
              <FormControl>
                <Input type="email" placeholder="orinak@mail.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="service" rules={{
      required: "Խնդրում ենք ընտրել ծառայությունը"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Հետաքրքրող ծառայություն</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Ընտրեք ծառայությունը" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {serviceOptions.map((option, i) => <SelectItem key={option.value} value={option.value} data-index={i}>
                    {option.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Հաղորդագրությունը պարտադիր է",
      minLength: {
        value: 10,
        message: "Նվազագույնը 10 նիշ"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Նախագծի մանրամասներ</FormLabel>
            <FormControl>
              <Textarea placeholder="Նկարագրեք Ձեր նախագիծը կամ հարցը..." className="min-h-[120px] resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-sm text-destructive font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px]">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Ուղարկվում է...
          </> : <>
            <Send className="mr-2 size-4" />
            Ուղարկել հարցումը
          </>}
      </Button>
    </Form>;
}
export default function ContactSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}